import React from 'react';
import CareerAssessment from '../components/career/CareerAssessment';

const CareerAssessmentPage = () => {
  return <CareerAssessment />;
};

export default CareerAssessmentPage;
